//Utils
import { createContext } from "../../../utils";

const Context = createContext({});

export const Provider = Context.Provider;
export const Consumer = Context.Consumer;
